import { render } from "./TheAutoActionsList.vue?vue&type=template&id=363a9c56"
import script from "./TheAutoActionsList.vue?vue&type=script&lang=js"
export * from "./TheAutoActionsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__